import type { CSSProperties } from 'react';
import { BackButton } from '../BackButton';
import {
  BadgeContainer,
  DefaultBadge,
  ImageContainer,
  Img,
  Outer,
  OuterSticky,
  Overlay,
  Placeholder,
} from './SideImage.styles';
import type { SideImageProps } from './SideImage.types';

function SideImageBase({
  src,
  alt = '',
  overlayContent,
  onBack,
  badge,
  mobileHeight,
  desktopHeight,
  sticky = true,
}: SideImageProps) {
  const WrapperEl = sticky ? OuterSticky : Outer;

  const cssVars = {
    ...(mobileHeight ? { '--side-image-mobile-height': mobileHeight } : {}),
    ...(desktopHeight ? { '--side-image-desktop-height': desktopHeight } : {}),
  } as CSSProperties;

  const showOverlay = overlayContent || onBack;

  return (
    <WrapperEl>
      <ImageContainer style={cssVars}>
        {src ? <Img src={src} alt={alt} /> : <Placeholder />}
        {showOverlay && (
          <Overlay>
            {onBack && <BackButton onClick={onBack} variant="overlay" />}
            {overlayContent}
          </Overlay>
        )}
        {badge && <BadgeContainer>{badge}</BadgeContainer>}
      </ImageContainer>
    </WrapperEl>
  );
}

export const SideImage = Object.assign(SideImageBase, {
  Badge: DefaultBadge,
});
